(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('log-type', {
            parent: 'entity',
            url: '/log-type',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.logType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/log-type/log-types.html',
                    controller: 'LogTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('log-type-detail', {
            parent: 'log-type',
            url: '/log-type/{id}',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.logType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/log-type/log-type-detail.html',
                    controller: 'LogTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LogType', function($stateParams, LogType) {
                    return LogType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'log-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('log-type.new', {
            parent: 'log-type',
            url: '/create',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/log-type/log-type-dialog.html',
                    controller: 'LogTypeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                createdDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
        })
		.state('log-type.edit', {
            parent: 'log-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.logType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/log-type/log-type-dialog.html',
                    controller: 'LogTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LogType', function($stateParams, LogType) {
                    return LogType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'log-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
      
        .state('log-type.delete', {
            parent: 'log-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/log-type/log-type-delete-dialog.html',
                    controller: 'LogTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['LogType', function(LogType) {
                            return LogType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('log-type', null, { reload: 'log-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
